import React from "react";
import s from "./style.module.css";
import { SubHeading } from "../Elements";
import Arrow from "../Arrow";
import cn from "classnames";

const DownloadBlock = ({
  title,
  description,
  downloadLink,
  downloadLinks = [],
  chapter,
  chapterCopy,
  downloadCopy,
}) => {
  const titleText = chapter ? `${chapterCopy} ${chapter}. ${title}` : title;

  return (
    <div
      className={cn(s.wrap, { [s.hasDownloadLinks]: downloadLinks.length > 0 })}
    >
      <div>
        <SubHeading className={s.title} tag={"h3"}>
          {titleText}
        </SubHeading>
        {description && <div className={s.description}>{description}</div>}
      </div>

      <div className={s.downloads}>
        {downloadLink && (
          <a
            href={downloadLink}
            className={s.button}
            target="_blank"
            rel="noreferrer"
          >
            {downloadCopy}
            <Arrow dir="right" />
          </a>
        )}
      </div>

      {downloadLinks.length > 0 && (
        <div className={s.allDownlaods}>
          {downloadLinks.map(({ url, language }, i) => (
            <a
              key={i}
              href={url}
              className={s.simpleButton}
              target="_blank"
              rel="noreferrer"
            >
              {language}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default DownloadBlock;
